import {useEffect, useState} from 'react'
import {Field, ErrorMessage, Formik, Form} from 'formik'
import useUtils from '../useUtils'
import * as Yup from 'yup'
import AssignConfirmation from '../../../modules/alert/AssignConfirmation'
function Step1() {
  const {modifySettings, fetchSettings} = useUtils()
  const [settings, setSettings] = useState(null)
  const [isOpen, setIsOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formKey, setFormKey] = useState(0)
  const getSettings = async () => {
    try {
      setIsLoading(true)
      const data = await fetchSettings()
      setSettings(data)
    } catch (error) {
      console.error('Error fetching settings:', error?.message)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    getSettings()
  }, [])

  const currentSchema = Yup.object({
    singleLoginBusinessId: Yup.number()
      .required('Single Login Business ID is required')
      .label('Single Login Business ID'),
    trendingVideoCount: Yup.number()
      .required('Trending Videos count is required')
      .label('Trending Videos'),
    couponAppModuleId: Yup.number()
      .required('Coupon App Module ID is required')
      .label('Coupon App Module ID'),
    couponAppPublicKey: Yup.string()
      .required('Coupon App Public Key is required')
      .label('Coupon App Public Key'),
    couponAppPrivateKey: Yup.string()
      .required('Coupon App Private Key is required')
      .label('Coupon App Private Key'),
    couponId: Yup.number().required('Coupon Id is required').label('Coupon ID'),
    chatGptApiKey: Yup.string().required('Chat GPT API Key is required').label('Chat GPT API Key'),
  })

  const handleSubmit = async (values) => {
    try {
      setIsLoading(true)
      // Trim spaces from all string fields
      const trimmedValues = Object.fromEntries(
        Object.entries(values).map(([key, value]) =>
          typeof value === 'string' ? [key, value.replace(/\s/g, '')] : [key, value]
        )
      )
      const {id, ...rest} = trimmedValues
      let response = await modifySettings(id, rest)
      if (response) {
        const latestSettings = await fetchSettings()
        setSettings({...latestSettings})
        setFormKey((prev) => prev + 1) //remount formik
      }
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className='d-flex flex-column align-items-start mx-auto  w-100 pt-15 pb-10'>
      {isLoading ? (
        <div className='d-flex w-100 justify-content-center'>
          <div className='spinner-border text-primary' role='status'>
            <span className='visually-hidden'>Loading...</span>
          </div>
        </div>
      ) : (
        <Formik
          key={formKey}
          enableReinitialize
          initialValues={{
            id: settings?.id || '',
            singleLoginBusinessId: settings?.singleLoginBusinessId || '',
            trendingVideoCount: settings?.trendingVideoCount || '',
            couponAppModuleId: settings?.couponAppModuleId || '',
            couponAppPublicKey: settings?.couponAppPublicKey || '',
            couponAppPrivateKey: settings?.couponAppPrivateKey || '',
            couponId: settings?.couponId || '',
            vimeoAccessToken: settings?.vimeoAccessToken || '',
            chatGptApiKey: settings?.chatGptApiKey || '',

            stripeApiSecret: settings?.stripeApiSecret || '',
            stripeWebhookSecret: settings?.stripeWebhookSecret || '',
            stripeProductId: settings?.stripeProductId || '',
            paystackApiSecret: settings?.paystackApiSecret || '',
          }}
          validationSchema={currentSchema}
          onSubmit={handleSubmit}
        >
          {({values, setFieldValue}) => (
            <Form id='kt_create_account_form'>
              <div className='w-100'>
                <div className='row mb-2' data-kt-buttons='true'>
                  <div className='mb-5 fv-row col-lg-4 ms-auto me-auto'>
                    <label className='col col-form-label required fw-bold fs-6'>
                      Coupon App Business ID
                    </label>
                    <Field
                      type='number'
                      className='form-control form-control-lg form-control-solid'
                      name='singleLoginBusinessId'
                      onChange={(e) =>
                        setFieldValue('singleLoginBusinessId', Number(e.target.value))
                      }
                    />
                    <div className='text-danger mt-2'>
                      <ErrorMessage name='singleLoginBusinessId' />
                    </div>
                  </div>
                  <div className='mb-5 fv-row col-lg-4 ms-auto me-auto'>
                    <label className='col col-form-label required fw-bold fs-6'>
                      Coupon App Module ID
                    </label>
                    <Field
                      type='number'
                      className='form-control form-control-lg form-control-solid'
                      name='couponAppModuleId'
                      onChange={(e) => setFieldValue('couponAppModuleId', Number(e.target.value))}
                    />
                    <div className='text-danger mt-2'>
                      <ErrorMessage name='couponAppModuleId' />
                    </div>
                  </div>

                  <div className='mb-5 fv-row col-lg-4  ms-auto me-auto'>
                    <label className='col col-form-label required fw-bold fs-6'>Coupon ID</label>
                    <Field
                      type='number'
                      className='form-control form-control-lg form-control-solid'
                      name='couponId'
                      onChange={(e) => setFieldValue('couponId', Number(e.target.value))}
                    />
                    <div className='text-danger mt-2'>
                      <ErrorMessage name='couponId' />
                    </div>
                  </div>

                  <div className='mb-5 fv-row col-lg-4  ms-auto me-auto'>
                    <label className='col col-form-label required fw-bold fs-6'>
                      Coupon App Public Key
                    </label>
                    <Field
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      name='couponAppPublicKey'
                      onChange={(e) => setFieldValue('couponAppPublicKey', e.target.value)}
                    />
                    <div className='text-danger mt-2'>
                      <ErrorMessage name='couponAppPublicKey' />
                    </div>
                  </div>

                  <div className='mb-5 fv-row col-lg-4  ms-auto me-auto'>
                    <label className='col col-form-label required fw-bold fs-6'>
                      Coupon App Private Key
                    </label>
                    <Field
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      name='couponAppPrivateKey'
                      onChange={(e) => setFieldValue('couponAppPrivateKey', e.target.value)}
                    />
                    <div className='text-danger mt-2'>
                      <ErrorMessage name='couponAppPrivateKey' />
                    </div>
                  </div>

                  <div className='mb-5 fv-row col-lg-4  ms-auto me-auto'>
                    <label className='col col-form-label required fw-bold fs-6'>
                      Vimeo Access Token
                    </label>
                    <Field
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      name='vimeoAccessToken'
                      onChange={(e) => setFieldValue('vimeoAccessToken', e.target.value)}
                    />
                    <div className='text-danger mt-2'>
                      <ErrorMessage name='vimeoAccessToken' />
                    </div>
                  </div>

                  <div className='mb-10 fv-row col-lg-4  ms-auto me-auto'>
                    <label className='col-form-label fw-bold required fs-6'>
                      Stripe Api Secret
                    </label>
                    <Field
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      name='stripeApiSecret'
                      onChange={(e) => setFieldValue('stripeApiSecret', e.target.value)}
                    />
                    <div className='text-danger mt-2'>
                      <ErrorMessage name='stripeApiSecret' />
                    </div>
                  </div>

                  <div className='mb-10 fv-row col-lg-4  ms-auto me-auto'>
                    <label className='col-form-label fw-bold required fs-6'>
                      stripeWebhookSecret
                    </label>
                    <Field
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      name='stripeWebhookSecret'
                      onChange={(e) => setFieldValue('stripeWebhookSecret', e.target.value)}
                    />
                    <div className='text-danger mt-2'>
                      <ErrorMessage name='stripeWebhookSecret' />
                    </div>
                  </div>

                  <div className='mb-10 fv-row col-lg-4  ms-auto me-auto'>
                    <label className='col-form-label fw-bold required fs-6'>
                      Stripe Product Id
                    </label>
                    <Field
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      name='stripeProductId'
                      onChange={(e) => setFieldValue('stripeProductId', e.target.value)}
                    />
                    <div className='text-danger mt-2'>
                      <ErrorMessage name='stripeProductId' />
                    </div>
                  </div>

                  <div className='mb-10 fv-row col-lg-4  ms-auto me-auto'>
                    <label className='col-form-label fw-bold required fs-6'>
                      Paystack Api Secret
                    </label>
                    <Field
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      name='paystackApiSecret'
                      onChange={(e) => setFieldValue('paystackApiSecret', e.target.value)}
                    />
                    <div className='text-danger mt-2'>
                      <ErrorMessage name='paystackApiSecret' />
                    </div>
                  </div>

                  <div className='mb-10 fv-row col-lg-4  ms-auto me-auto'>
                    <label className='col-form-label fw-bold required fs-6'>ChatGPT API Key</label>
                    <Field
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      name='chatGptApiKey'
                      onChange={(e) => setFieldValue('chatGptApiKey', e.target.value)}
                    />
                    <div className='text-danger mt-2'>
                      <ErrorMessage name='chatGptApiKey' />
                    </div>
                  </div>

                  <div className='mb-10 fv-row col-lg-4  ms-auto me-auto'>
                    <label className='col-form-label fw-bold required fs-6'>Trending Videos</label>
                    <Field
                      type='number'
                      className='form-control form-control-lg form-control-solid'
                      name='trendingVideoCount'
                      onChange={(e) => setFieldValue('trendingVideoCount', Number(e.target.value))}
                    />
                    <div className='text-danger mt-2'>
                      <ErrorMessage name='trendingVideoCount' />
                    </div>
                  </div>
                </div>
              </div>

              <div className='d-flex flex-center pt-7'>
                <div>
                  <button
                    type='button'
                    onClick={() => {
                      setIsOpen(true)
                    }}
                    className='btn btn-lg btn-primary me-3'
                  >
                    <span className='indicator-label'>Save</span>
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      )}
      <AssignConfirmation
        isVisible={isOpen}
        message='Are you sure you want to update the Settings?'
        onConfirm={() => {
          setIsOpen(false)
          setTimeout(() => {
            document.querySelector('form')?.requestSubmit()
          }, 0)
        }}
        onCancel={() => setIsOpen(false)}
      />
    </div>
  )
}

export default Step1
